<div class="hmn-plain-toolbar hmn-row__space hmn-width__full hmn-position__fixed">
  <app-shared-logo
    style="height: 25.8px"
    [logo_src]="'../../../assets/imgs/logo/logo_icon.svg'"
    [logo_class]="'hmn-shared-logo__s'"></app-shared-logo>

  <app-shared-icon-button
    [icon]="'help'"
    [icon_class]="'material-symbols-outlined'"
    [button_class]="icon_button_class"
    (button_click)="onHelpClick()"></app-shared-icon-button>
</div>
